// ============================================================================
// FRENCH TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Questions amusantes mais réfléchies

export const funQuestions = [
  {
    question: "Si Jésus avait eu un téléphone, qui aurait été son premier contact ?",
    emoji: "📱",
    theme: "relation_divine"
  },
  {
    question: "Pourquoi David n'a-t-il jamais perdu ses moutons ?",
    emoji: "🐑", 
    theme: "berger"
  },
  {
    question: "Combien coûte l'amour de Dieu ?",
    emoji: "💰",
    theme: "grâce"
  },
  {
    question: "Quelle est la différence entre la paix de Dieu et une sieste ?",
    emoji: "😴",
    theme: "paix"
  },
  {
    question: "Pourquoi la Parole de Dieu ne tombe jamais en panne de batterie ?",
    emoji: "🔋",
    theme: "parole"
  },
  {
    question: "Si Moïse avait eu un GPS, aurait-il erré 40 ans dans le désert ?",
    emoji: "🗺️",
    theme: "guidance"
  },
  {
    question: "Pourquoi les anges n'ont-ils jamais besoin de faire du sport ?",
    emoji: "👼",
    theme: "perfection"
  },
  {
    question: "Que dirait Salomon des réseaux sociaux modernes ?",
    emoji: "📱",
    theme: "sagesse"
  }
];

export default funQuestions;
